/*
    handle toggling visibility of global header language switch,
    when user interacts with the relevant button
*/
export default function () {
    // retrieve button which toggles visibility of the languages list
    const languageSwitchButtons = document.getElementsByClassName("language_switch_button");
    if (languageSwitchButtons) {
        Array.from(languageSwitchButtons).forEach((languageSwitchButton) => {
            // retrieve the languages list
            const languageSwitchList = languageSwitchButton.parentElement.getElementsByClassName("language_switch_list");
            // if both of these elements are present
            if (languageSwitchButton && languageSwitchList) {
                // on user interaction with the language switch button
                languageSwitchButton.onclick = () => {
                    languageSwitchList[0].classList.toggle("language_switch_list--is_visible");
                };
            }
        });
    }
}
